module.exports = __webpack_public_path__ + "metroIcons_light.8fe485dd7a6c9b7a7d06.jpg";


//////////////////
// WEBPACK FOOTER
// ./~/metrojs/release/MetroJs.Full/images/metroIcons_light.jpg
// module id = 277
// module chunks = 13